import { ReactElement, useEffect } from 'react';

import { useFormController } from '@dreryk/react-common';
import { getPreviousWorkweekEnd, isWeekendDate } from '@dreryk/react-calendar';

import { WeekendsVisibilityPreferenceField } from '~libs.desktop.shared.appointments-timetable';

import {
   ScheduleTimetableActionsFormBean,
   ScheduleTimetableSelectedDate,
   ScheduleTimetableSelectedDateSetter,
} from './ScheduleTimetableActions.types';
import { useWeekendsVisibilityPreference } from './ScheduleTimetableActions.hooks';

type ScheduleTimetableActionsProps = {
   selectedDate: ScheduleTimetableSelectedDate;
   setSelectedDate: ScheduleTimetableSelectedDateSetter;
};

export const ScheduleTimetableActions = (props: ScheduleTimetableActionsProps): ReactElement => {
   const [preferWeekendsVisible, setWeekendsVisibilityPreference] = useWeekendsVisibilityPreference();
   const { register, watch } = useFormController<ScheduleTimetableActionsFormBean>({
      preferWeekendsVisible: preferWeekendsVisible,
   });

   const currentPreferWeekendsVisible = watch('preferWeekendsVisible');

   useEffect(() => {
      setWeekendsVisibilityPreference(currentPreferWeekendsVisible);
      if (!preferWeekendsVisible && isWeekendDate(props.selectedDate)) {
         props.setSelectedDate(getPreviousWorkweekEnd(props.selectedDate));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentPreferWeekendsVisible]);

   return <WeekendsVisibilityPreferenceField register={register} />;
};
